import { ApplicationApi, ConfigurationApi, TenantApi, RoleApi, UserApi } from '../api';

import { BASEPATH } from './constants';

export const applicationApi = new ApplicationApi(undefined, BASEPATH);
export const configurationApi = new ConfigurationApi(undefined, BASEPATH);
export const tenantApi = new TenantApi(undefined, BASEPATH);
export const roleApi = new RoleApi(undefined, BASEPATH);
export const userApi = new UserApi(undefined, BASEPATH);
